import React from 'react'
import View from '../../../../../components/pdf/View'
import { Col } from '../../../../../components/pdf/Grid'
import Text from '../../../../../components/pdf/Text'

const Inventory = () => {
  return (
    <View
      pageBreakAfter
      style={{ minHeight: '27cm', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
    >
      <Col>
        <Text size={40} bold preLine style={{ lineHeight: 1 }}>
          {'Inventário de\nRiscos Ergonômicos'}
        </Text>
      </Col>
    </View>
  )
}

export default Inventory
